import { Types } from "@grandvisionhq/graphql";
import { isDefined, getLocalizedString, formatPrice } from "@grandvisionhq/utils";
import { IN_STORE_SUBSCRIPTION_PURCHASE, SUBSCRIPTION_PURCHASE, SINGLE_PURCHASE } from "../../../../../../types/types/purchase-types.js";
const getDiscountBadge = (locale, currency, serverDiscountedPrice) => {
  if (!serverDiscountedPrice || !serverDiscountedPrice.discountInformation) {
    return void 0;
  }
  const { type, value } = serverDiscountedPrice.discountInformation;
  if (!value) {
    return void 0;
  }
  if (type === Types.DiscountType.RELATIVE) {
    return `-${value}%`;
  }
  if (type === Types.DiscountType.ABSOLUTE) {
    const formattedDiscount = formatPrice({ locale, value, currency, isCentAmount: false });
    return `-${formattedDiscount}`;
  }
};
const getPurchaseTypePrice = (serverPrice, locale) => {
  if (!serverPrice || !serverPrice.originalPrice) {
    return void 0;
  }
  const currency = serverPrice.originalPrice.currencyCode;
  const originalPrice = serverPrice.originalPrice.amount;
  const discountedPrice = serverPrice.discountedPrice?.price?.amount;
  let discountInfo;
  if (isDefined(discountedPrice)) {
    const { discountInformation } = serverPrice.discountedPrice ?? {};
    const { description, validity } = discountInformation ?? {};
    const discountBadge = getDiscountBadge(locale, currency, serverPrice.discountedPrice);
    const discountDescription = description && getLocalizedString(description, locale);
    discountInfo = {
      discountDescription,
      discountBadge,
      validFrom: validity?.validFrom ?? void 0,
      validUntil: validity?.validUntil ?? void 0
    };
  }
  const loyaltyPoints = serverPrice.loyaltyPoints;
  const pricePerUnit = !!serverPrice.pricePerUnit?.amount ? serverPrice.pricePerUnit?.amount : void 0;
  return {
    currency,
    isCentAmount: false,
    originalPrice,
    discountedPrice,
    discountInfo,
    loyaltyPoints,
    pricePerUnit
  };
};
const getPurchaseTypePrices = (serverPriceList, locale, priceSegmentChannelKey) => {
  const singlePurchasePriceListRaw = serverPriceList.filter(
    (price) => price.priceType === Types.ProductPriceItemType.SINGLE_PURCHASE
  );
  const singlePurchasePriceSegmentRaw = singlePurchasePriceListRaw.find(
    (price) => price.priceSegment?.channelKey === priceSegmentChannelKey
  );
  const singlePurchasePriceDefaultRaw = singlePurchasePriceListRaw.find(
    (price) => !price.priceSegment?.channelKey
  );
  const subscriptionPurchasePriceRaw = serverPriceList.find(
    (price) => price.priceType === Types.ProductPriceItemType.SUBSCRIPTION
  );
  const singlePurchasePrice = getPurchaseTypePrice(
    singlePurchasePriceSegmentRaw || singlePurchasePriceDefaultRaw,
    locale
  );
  const subscriptionPurchasePrice = getPurchaseTypePrice(subscriptionPurchasePriceRaw, locale);
  const inStoreSubscriptionPurchasePrice = getPurchaseTypePrice(
    singlePurchasePriceDefaultRaw,
    locale
  );
  if (!singlePurchasePrice) {
    return void 0;
  }
  return {
    [SINGLE_PURCHASE]: singlePurchasePrice,
    [SUBSCRIPTION_PURCHASE]: subscriptionPurchasePrice,
    [IN_STORE_SUBSCRIPTION_PURCHASE]: inStoreSubscriptionPurchasePrice
  };
};
export {
  getPurchaseTypePrices
};
//# sourceMappingURL=get-purchase-type-prices.js.map
